export default __webpack_public_path__ + "static/media/truck-bg.c5923dd2.png";